import fidoBold from "../../static/fonts/fido/Fido-Bold.woff2";
import workSansRegular from "../../static/fonts/work-sans/WorkSans-Regular.woff2";

// import "../../theme/theme.scss";
import { Script } from "gatsby";
import React, { type PropsWithChildren } from "react";
import favicon from "../../static/favicon.ico";

interface HeadProps extends PropsWithChildren {
	hrefLangUrl?: string;
	pageUrl: string;
}
export const Head: React.FC<HeadProps> = ({
	hrefLangUrl,
	pageUrl,
	children,
}) => (
	<>
		{(process.env.GATSBY_NO_INDEX_FOLLOW === "true" ||
			process.env.GATSBY_IS_PREVIEW === "true") && (
			<meta name="robots" content="noindex,nofollow" />
		)}
		<link rel="shortcut icon" type="image/x-icon" href={favicon} />
		<link rel="preload" as="font" type="font/woff2" href={fidoBold} />
		<link rel="preload" as="font" type="font/woff2" href={workSansRegular} />
		{hrefLangUrl && (
			<>
				<link
					rel="alternate"
					hrefLang={"en-gb"}
					href={`${process.env.GATSBY_DOMAIN_NAME}${pageUrl}`}
				/>
				<link rel="alternate" hrefLang={"en-ie"} href={`${hrefLangUrl}`} />
				<link
					rel="alternate"
					hrefLang="x-default"
					href={`${process.env.GATSBY_DOMAIN_NAME}${pageUrl}`}
				/>
			</>
		)}
		<Script
			id="onetrust-cookie-script"
			async
			src="https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js"
			type="text/javascript"
			charSet="UTF-8"
			data-domain-script={`${process.env.GATSBY_ONETRUST_COOKIE_ID}`}
		/>
		<Script type="text/javascript">{"function OptanonWrapper() { }"}</Script>
		<Script
			async
			src={`https://www.googleoptimize.com/optimize.js?id=${process.env.GATSBY_GO_ID}`}
			type="text/javascript"
		/>
		<script
			type="text/javascript"
			src="//c.webtrends-optimize.com/acs/accounts/89d38ba3-d6e2-4fda-864b-3ced983c69a0/js/wt.js"
		/>
		{children}
	</>
);
